require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-kittsee.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-kittsee");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-kittsee!./.cache/json/betreuungseinrichtungen-neusiedl-kittsee.json
// module id = 954
// module chunks = 231608221292675